export default __webpack_public_path__ + "static/media/ionic.711c6d3d.svg";